<!-- PREFERRED DEALER HEADER -->
<div class="gb-headline2" role="heading" aria-level="2"
  [translate]="activeVinAppts && activeVinAppts.length > 0? 'accessories_preferredDealerHeader_yourService' : 'accessories_preferredDealerHeader_webu'">
</div>
<hr class="cit2 mt-6 mb-6">

<!-- BODY -->
<ng-container [ngSwitch]="widget.state">
  
  <!-- LOADING -->
  <ox-loading *ngSwitchCase="'loading'"></ox-loading>

  <ng-container *ngSwitchCase="'loaded'">
      <!-- UPCOMING SERVICE -->
    <div *ngIf="hasUpcomingService">
      <ul class="mb-6">
        <li class="mb-0" *ngFor="let activeVinAppt of activeVinAppts.slice(0, apptLimit)">
          <div class="mb-6">
            <div class="gb-body1 heavy mb-3" [translate]="activeVinAppt.month"
              [translateParams]="{day:activeVinAppt.day, year:activeVinAppt.year, time:activeVinAppt.serviceLaneVisit.appointmentTime.start}">
            </div>
            <ul class="gb-body2 mb-3">
              <li class="mb-0" *ngFor="let lineItem of activeVinAppt.serviceLaneVisit.lineItems">
                {{lineItem.name}}
              </li>
            </ul>
            <ul class="mb-0">
              <li class="mb-3 gb-body1">
                <a (click)="changeThis(activeVinAppt.serviceLaneVisit)"
                  class="no-href"
                  evar33="vehicle profile:preferred dealer:link:manage appointment"
                  prop10="vehicle profile:preferred dealer:link:manage appointment" prop15="manage appointment"
                  [trackDelay]="'true'" [trackType]="'o'" [trackLink]="'dealer:manageAppointment'" tabindex="0">
                  <span [translate]="'upcoming_service_manage_appointment'"></span>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <div class="row mx-0" *ngIf="activeVinAppts.length > 1">
        <div class="col-6 gb-body2 px-0" [translate]="'total_appointments'"
          [translateParams]="{showing: apptLimit, total:activeVinAppts.length}">
        </div>
        <div class="col-6 gb-body2 textRight" [hidden]="allActiveAppts">
          <a id="showAllButton" (click)="toggle('showall')" [translate]="'show_all'"></a>
        </div>
        <div class="col-6 gb-body2 textRight" [hidden]="!allActiveAppts">
          <a id="showLessButton" (click)="toggle('showless')" [translate]="'show_less'"></a>
        </div>
      </div>
    </div>

    <!-- PREFERRED DEALER -->
    <div *ngIf="hasPreferredDealer">
      <webu-compact-dealer-info [dealer]="widget.dealer" [userAddress]="userAddress"
        [trackLink]="'Accessories:Dealer Phone'" [trackDelay]="'true'" [trackType]="'o'"
        [prop10]="'accessories:link:phone number'">
      </webu-compact-dealer-info>

      <div class="gb-medium-margin">
        <li class="row my-5">
          <span class="col-12 col-lg-6" evar33="vehicle profile:preferred dealer:button:schedule service"
            prop10="vehicle profile:preferred dealer:button:schedule service" prop15="schedule service"
            [trackDelay]="'true'" [trackType]="'o'" [trackLink]="'dealer:scheduleService'">
            <button class="gb-primary-button" [translate]="'preferredDealer_scheduleServiceBtn'"
              (click)="loadOss()" tabindex=”-1”>
            </button>
          </span>
        </li>
        <li class="row gb-body2">
          <span class="ml-2">
            <a class="py-0" (click)="onBeginSearch()"
              evar33="vehicle profile:preferred dealer:link:change preferred dealer"
              prop10="vehicle profile:preferred dealer:link:change preferred dealer"
              prop15="change preferred dealer" [trackDelay]="'true'" [trackType]="'o'"
              [trackLink]="'dealer:changePreferredDealer'" tabindex="0">
              <span [translate]="'preferredDealer_changePreferredDealer'"></span>
            </a>
          </span>
        </li>
      </div>
    </div>

    <!-- NO PREFERRED DEALER -->
    <div *ngIf="!hasPreferredDealer">
      <span class="row">
        <div class="gb-body1 mb-6 col-12" [translate]="'preferredDealerWidget_noDealer_message'"></div>
        <div class="col-12 col-lg-8">
          <span [trackDelay]="'true'" [trackType]="'o'" [trackLink]="'dealer:locateADealer'"
            evar33="'vehicle profile:preferred dealer:button:locate a dealer'"
            prop10="'vehicle profile:preferred dealer:button:locate a dealer'" prop15="'locate a dealer'">
            <button class="gb-primary-button" [translate]="'locateDealer_title'" (click)="onBeginSearch()" href="#"></button>
          </span>
        </div>
      </span>
    </div>
    
  </ng-container>

  <!-- CANNOT LOAD -->
  <ng-container *ngSwitchCase="'cannotLoad'">
    <div class="gb-body1 mb-6" [translate]="'preferredDealerWidget_noDealer_message'"></div>
  </ng-container>

</ng-container>

<ox-drawer-modal [(show)]="showDealerLocator" [bodyComponent]="locateDealer"
  [options]='{ ignoreBackdropClick: false, keyboard: false, id: "myModal"}'>
</ox-drawer-modal>